<template>
  <div class="moz-error">
    <div class="logo-smile">
      <img :src="require(`../assets/svg/face_sad.svg`)">
    </div>
    <div class="logo">
      <img :src="require(`../assets/svg/mozio.svg`)">
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MozError',
};
</script>

<style lang="scss" scoped>
  .moz-error {
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.88;
    color: #6f7f8f;
    margin: 48px 0 56px;

    @media screen and (min-width: $tablet-width) {
      margin: 80px;
      font-size: 16px;
    }

    .logo {
      height: 13px;
      margin: 16px 0 32px;

      @media screen and (min-width: $tablet-width) {
        height: auto;
      }
    }

    > span {
      display: block;
    }

    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }

    .logo-smile {
      height: 60px;

      @media screen and (min-width: $tablet-width) {
        height: auto;
      }
    }
  }
</style>
